import React from "react";
import { Outlet, Route } from "react-router-dom";
import "./DashboardLayout.css";
import Sidebar from "../Components/sidebar/SideBar";

const DashboardLayout = () => {
  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="dashboard-page-content">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;